

// import React, { useState } from 'react';
// import {
//   FaTimes,
//   FaUser,
//   FaPhone,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaDownload,
//   FaWhatsapp,
//   FaChartLine,
// } from 'react-icons/fa';

// import { motion, AnimatePresence } from 'framer-motion';
// import { toast } from 'react-toastify';

// const CalculatorForm = ({
//   onSubmit,
//   onClose,
//   calculatorType = 'SIP',
// }) => {

//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     location: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const validateForm = () => {

//     if (!formData.name.trim()) {
//       toast.error('Please enter your full name');
//       return false;
//     }

//     if (!formData.phone.trim()) {
//       toast.error('Please enter your phone number');
//       return false;
//     }

//     if (!/^[6-9]\d{9}$/.test(formData.phone)) {
//       toast.error('Please enter valid 10 digit mobile number');
//       return false;
//     }

//     if (
//       formData.email &&
//       !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
//     ) {
//       toast.error('Please enter valid email');
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setIsSubmitting(true);

//     try {

//       const existingLeads = JSON.parse(
//         localStorage.getItem('wisdom_leads') || '[]'
//       );

//       const newLead = {
//         ...formData,
//         calculatorType,
//         createdAt: new Date().toISOString(),
//       };

//       existingLeads.unshift(newLead);

//       localStorage.setItem(
//         'wisdom_leads',
//         JSON.stringify(existingLeads)
//       );

//       toast.success(
//         'Details submitted successfully!'
//       );

//       setTimeout(() => {
//         onSubmit(formData);
//         setIsSubmitting(false);
//       }, 800);

//     } catch (error) {

//       console.error(error);

//       toast.error(
//         'Something went wrong. Please try again.'
//       );

//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <AnimatePresence>

//       <motion.div
//         className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//       >

//         <motion.div
//           initial={{ scale: 0.9, opacity: 0, y: 20 }}
//           animate={{ scale: 1, opacity: 1, y: 0 }}
//           exit={{ scale: 0.9, opacity: 0, y: 20 }}
//           transition={{ duration: 0.3 }}
//           className="relative bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden"
//         >

//           {/* HEADER */}
//           <div className="bg-gradient-to-r from-[#1a3a5c] to-[#2c5f8a] p-6 text-white relative">

//             <button
//               onClick={onClose}
//               className="absolute top-4 right-4 text-white/80 hover:text-white"
//             >
//               <FaTimes size={20} />
//             </button>

//             <div className="flex items-center gap-4">

//               <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center backdrop-blur-md">
//                 <FaChartLine size={28} />
//               </div>

//               <div>
//                 <h3 className="text-2xl font-bold">
//                   Financial Report
//                 </h3>

//                 <p className="text-sm text-white/90 mt-1">
//                   Download your personalized {calculatorType} report
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* BODY */}
//           <div className="p-6">

//             <div className="text-center mb-6">
//               <h4 className="text-xl font-bold text-gray-900">
//                 Wisdom Consultancy
//               </h4>

//               <p className="text-sm text-gray-500 mt-2">
//                 Professional Financial Planning & Wealth Solutions
//               </p>
//             </div>

//             <form
//               onSubmit={handleSubmit}
//               className="space-y-4"
//             >

//               {/* NAME */}
//               <div className="relative">

//                 <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="text"
//                   placeholder="Full Name *"
//                   value={formData.name}
//                   onChange={(e) =>
//                     handleChange('name', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                   required
//                 />
//               </div>

//               {/* PHONE */}
//               <div className="relative">

//                 <FaPhone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="tel"
//                   placeholder="Mobile Number *"
//                   value={formData.phone}
//                   onChange={(e) =>
//                     handleChange(
//                       'phone',
//                       e.target.value.replace(/\D/g, '')
//                     )
//                   }
//                   maxLength={10}
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                   required
//                 />
//               </div>

//               {/* EMAIL */}
//               <div className="relative">

//                 <FaEnvelope className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="email"
//                   placeholder="Email Address"
//                   value={formData.email}
//                   onChange={(e) =>
//                     handleChange('email', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                 />
//               </div>

//               {/* LOCATION */}
//               <div className="relative">

//                 <FaMapMarkerAlt className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="text"
//                   placeholder="City / State"
//                   value={formData.location}
//                   onChange={(e) =>
//                     handleChange('location', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                 />
//               </div>

//               {/* BENEFITS */}
//               <div className="bg-[#f8fafc] rounded-2xl p-4 border border-gray-100 space-y-3">

//                 <div className="flex items-center gap-3 text-sm text-gray-700">
//                   <FaDownload className="text-[#2e56b8]" />
//                   Professional PDF Report
//                 </div>

//                 <div className="flex items-center gap-3 text-sm text-gray-700">
//                   <FaWhatsapp className="text-green-600" />
//                   WhatsApp Consultation Support
//                 </div>

//                 <div className="flex items-center gap-3 text-sm text-gray-700">
//                   <span className="text-green-600 font-bold">
//                     ✓
//                   </span>

//                   Free Financial Guidance
//                 </div>
//               </div>

//               {/* BUTTON */}
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className="w-full bg-gradient-to-r from-[#2e56b8] to-[#24479b] text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50"
//               >
//                 {isSubmitting
//                   ? 'Processing...'
//                   : '📥 Download Financial Report'}
//               </button>

//               {/* DISCLAIMER */}
//               <p className="text-xs text-center text-gray-400 leading-relaxed">
//                 Mutual Fund investments are subject to market risks.
//                 Read all scheme related documents carefully before investing.
//               </p>

//             </form>
//           </div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default CalculatorForm;

import React, { useState } from 'react';
import {
  FaTimes,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaDownload,
  FaWhatsapp,
  FaChartLine,
} from 'react-icons/fa';

import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-toastify';
import html2pdf from 'html2pdf.js';

const CalculatorForm = ({
  onSubmit,
  onClose,
  calculatorType = 'SIP',
  calculationData = null,
  userInputs = {},
}) => {

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    location: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error('Please enter your full name');
      return false;
    }

    if (!formData.phone.trim()) {
      toast.error('Please enter your phone number');
      return false;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      toast.error('Please enter valid 10 digit mobile number');
      return false;
    }

    if (
      formData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      toast.error('Please enter valid email');
      return false;
    }

    return true;
  };

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '₹0';
    return `₹${Number(amount || 0).toLocaleString('en-IN', {
      maximumFractionDigits: 0,
    })}`;
  };

  const formatLargeNumber = (amount) => {
    if (!amount && amount !== 0) return '₹0';
    return formatCurrency(amount);
  };

  const dateStr = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' });

  const mainCorpus = calculationData?.futureValue || calculationData?.sipFV || calculationData?.totalCorpus || calculationData?.finalBalance || 0;
  const totalInvestment = calculationData?.totalInvestment || calculationData?.totalInvestedSIP || calculationData?.investedAmount || 0;
  const totalReturns = calculationData?.totalReturns || calculationData?.estimatedReturns || Math.max(0, mainCorpus - totalInvestment);

  const getSummaryRowsHtml = () => {
    const rows = [];
    const s = 'padding:8px 12px;border:1px solid #c2d6e3;font-size:14px;';
    if (userInputs.childName)
      rows.push(`<tr><td style="${s};font-weight:bold">Child Name</td><td style="${s};text-align:right">${userInputs.childName}</td></tr>`);
    if (userInputs.childAge !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Child Current Age</td><td style="${s};text-align:right">${userInputs.childAge} Years</td></tr>`);
    if (userInputs.educationAge !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Education Goal Age</td><td style="${s};text-align:right">${userInputs.educationAge} Years</td></tr>`);
    if (userInputs.currentAge !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Current Age</td><td style="${s};text-align:right">${userInputs.currentAge} Years</td></tr>`);
    if (userInputs.retirementAge !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Retirement Age</td><td style="${s};text-align:right">${userInputs.retirementAge} Years</td></tr>`);
    if (userInputs.lifeExpectancy !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Life Expectancy</td><td style="${s};text-align:right">${userInputs.lifeExpectancy} Years</td></tr>`);
    if (userInputs.marriageAge !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Marriage Age</td><td style="${s};text-align:right">${userInputs.marriageAge} Years</td></tr>`);
    if (userInputs.currentEducationCost !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Current Education Cost</td><td style="${s};text-align:right">${formatCurrency(userInputs.currentEducationCost)}</td></tr>`);
    if (userInputs.currentMarriageCost !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Current Wedding Cost</td><td style="${s};text-align:right">${formatCurrency(userInputs.currentMarriageCost)}</td></tr>`);
    if (userInputs.currentSavings !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Current Savings</td><td style="${s};text-align:right">${formatCurrency(userInputs.currentSavings)}</td></tr>`);
    if (userInputs.existingSavings !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Existing Savings</td><td style="${s};text-align:right">${formatCurrency(userInputs.existingSavings)}</td></tr>`);
    if (userInputs.monthlyExpense !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Monthly Expense</td><td style="${s};text-align:right">${formatCurrency(userInputs.monthlyExpense)}</td></tr>`);
    if (userInputs.monthlyWithdrawal !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Monthly Withdrawal</td><td style="${s};text-align:right">${formatCurrency(userInputs.monthlyWithdrawal)}</td></tr>`);
    if (userInputs.monthlyInvestment !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Monthly SIP</td><td style="${s};text-align:right">${formatCurrency(userInputs.monthlyInvestment)}</td></tr>`);
    if (userInputs.monthlySIP !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Monthly SIP</td><td style="${s};text-align:right">${formatCurrency(userInputs.monthlySIP)}</td></tr>`);
    if (userInputs.lumpsumAmount !== undefined && userInputs.lumpsumAmount > 0)
      rows.push(`<tr><td style="${s};font-weight:bold">Lumpsum Amount</td><td style="${s};text-align:right">${formatCurrency(userInputs.lumpsumAmount)}</td></tr>`);
    if (userInputs.stepUpRate !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Step-Up Rate</td><td style="${s};text-align:right">${userInputs.stepUpRate}%</td></tr>`);
    if (userInputs.annualStepUp !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Annual Step-Up</td><td style="${s};text-align:right">${userInputs.annualStepUp}%</td></tr>`);
    if (userInputs.expectedReturn !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Expected Return</td><td style="${s};text-align:right">${userInputs.expectedReturn}% p.a.</td></tr>`);
    if (userInputs.expectedReturnSIP !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Return (SIP)</td><td style="${s};text-align:right">${userInputs.expectedReturnSIP}% p.a.</td></tr>`);
    if (userInputs.inflationRate !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Inflation Rate</td><td style="${s};text-align:right">${userInputs.inflationRate}% p.a.</td></tr>`);
    if (userInputs.timePeriod !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Duration</td><td style="${s};text-align:right">${userInputs.timePeriod} Years</td></tr>`);
    if (userInputs.sipTenure !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">SIP Tenure</td><td style="${s};text-align:right">${userInputs.sipTenure} Years</td></tr>`);
    if (userInputs.yearlyStepUp !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Yearly Step-Up</td><td style="${s};text-align:right">${formatCurrency(userInputs.yearlyStepUp)}</td></tr>`);
    if (userInputs.withdrawalStartAge !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Withdrawal Start Age</td><td style="${s};text-align:right">${userInputs.withdrawalStartAge} Years</td></tr>`);
    if (userInputs.increasePercentage !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Withdrawal Increase</td><td style="${s};text-align:right">${userInputs.increasePercentage}% Yearly</td></tr>`);
    if (userInputs.expectedReturnWithdrawal !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Return (SWP)</td><td style="${s};text-align:right">${userInputs.expectedReturnWithdrawal}% p.a.</td></tr>`);
    if (userInputs.withdrawalPeriod !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Withdrawal Period</td><td style="${s};text-align:right">${userInputs.withdrawalPeriod} Years</td></tr>`);
    return rows.join('');
  };

  const getResultRowsHtml = () => {
    const s = 'padding:8px 12px;border:1px solid #c2d6e3;font-size:14px;';
    const rows = [];
    
    // Retirement specific
    if (calculationData?.yearsToRetirement !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Years to Retirement</td><td style="${s};text-align:right">${calculationData.yearsToRetirement} Years</td></tr>`);
    if (calculationData?.futureValueOfSavings !== undefined && calculationData?.futureValueOfSIP !== undefined) {
      rows.push(`<tr><td style="${s};font-weight:bold">Growth of Current Savings</td><td style="${s};text-align:right">${formatCurrency(calculationData.futureValueOfSavings)}</td></tr>`);
      rows.push(`<tr><td style="${s};font-weight:bold">Growth of Monthly SIP</td><td style="${s};text-align:right">${formatCurrency(calculationData.futureValueOfSIP)}</td></tr>`);
    }
    if (calculationData?.requiredCorpus !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Required Corpus</td><td style="${s};text-align:right">${formatCurrency(calculationData.requiredCorpus)}</td></tr>`);
    if (calculationData?.inflationAdjustedExpense !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Monthly Expense at Retirement</td><td style="${s};text-align:right">${formatCurrency(calculationData.inflationAdjustedExpense)}</td></tr>`);
    
    // Child Education & Marriage specific
    if (calculationData?.futureCost !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold;color:#e07a00">Future Goal Cost</td><td style="${s};text-align:right;font-weight:bold;color:#e07a00">${formatCurrency(calculationData.futureCost)}</td></tr>`);
    if (calculationData?.sipFutureValue !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">SIP Growth</td><td style="${s};text-align:right">${formatCurrency(calculationData.sipFutureValue)}</td></tr>`);
    if (calculationData?.requiredMonthlySIP !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Required Monthly SIP</td><td style="${s};text-align:right">${formatCurrency(calculationData.requiredMonthlySIP)}</td></tr>`);
    
    // SWP specific
    if (calculationData?.totalWithdrawn !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Total Withdrawn</td><td style="${s};text-align:right">${formatCurrency(calculationData.totalWithdrawn)}</td></tr>`);
    if (calculationData?.finalBalance !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Final Balance</td><td style="${s};text-align:right">${formatCurrency(calculationData.finalBalance)}</td></tr>`);
    if (calculationData?.years !== undefined && calculationData?.remainingMonths !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Withdrawal Duration</td><td style="${s};text-align:right">${calculationData.years} Years ${calculationData.remainingMonths} Months</td></tr>`);

    // Common fields
    if (totalInvestment > 0 && calculationData?.futureCost === undefined && calculationData?.totalWithdrawn === undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Total Invested</td><td style="${s};text-align:right">${formatLargeNumber(totalInvestment)}</td></tr>`);
    if (totalReturns > 0 && calculationData?.futureCost === undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Estimated Returns / Interest</td><td style="${s};text-align:right">${formatLargeNumber(totalReturns)}</td></tr>`);
    if (mainCorpus > 0 && calculationData?.totalWithdrawn === undefined)
      rows.push(`<tr><td style="${s};font-weight:bold;color:#1f4b8f">Total Expected Corpus</td><td style="${s};text-align:right;font-weight:bold;color:#1f4b8f">${formatLargeNumber(mainCorpus)}</td></tr>`);
    
    // Status fields for Goal based calculators
    if (calculationData?.isSufficient !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Status</td><td style="${s};text-align:right;font-weight:bold;color:${calculationData.isSufficient ? 'green' : 'red'}">${calculationData.isSufficient ? '✅ Goal Achievable' : '⚠️ Need more savings'}</td></tr>`);
    if (!calculationData?.isSufficient && calculationData?.additionalMonthlyInvestment)
      rows.push(`<tr><td style="${s};font-weight:bold;color:red">Additional SIP Needed</td><td style="${s};text-align:right;color:red;font-weight:bold">${formatCurrency(calculationData.additionalMonthlyInvestment)}/month</td></tr>`);
    
    // ComboCalculator specific
    if (calculatorType === 'ComboCalculator' && calculationData) {
      if (calculationData.sipFV !== undefined)
        rows.push(`<tr><td style="${s};font-weight:bold;color:#2e56b8">Step-Up SIP Future Value</td><td style="${s};text-align:right;font-weight:bold;color:#2e56b8">${formatCurrency(calculationData.sipFV)}</td></tr>`);
      if (calculationData.totalWithdrawn !== undefined)
        rows.push(`<tr><td style="${s};font-weight:bold;color:#e07a00">Total Withdrawn (SWP)</td><td style="${s};text-align:right;font-weight:bold;color:#e07a00">${formatCurrency(calculationData.totalWithdrawn)}</td></tr>`);
      if (calculationData.finalCorpus !== undefined)
        rows.push(`<tr><td style="${s};font-weight:bold;color:#69bf74">Final Remaining Corpus</td><td style="${s};text-align:right;font-weight:bold;color:#69bf74">${formatCurrency(calculationData.finalCorpus)}</td></tr>`);
    }

    if (calculationData?.isTargetReached !== undefined)
      rows.push(`<tr><td style="${s};font-weight:bold">Status</td><td style="${s};text-align:right;font-weight:bold;color:${calculationData.isTargetReached ? 'green' : 'red'}">${calculationData.isTargetReached ? '✅ Goal On Track!' : '⚠️ Need more savings'}</td></tr>`);
    if (!calculationData?.isTargetReached && calculationData?.additionalMonthlyNeeded)
      rows.push(`<tr><td style="${s};font-weight:bold;color:red">Additional SIP Needed</td><td style="${s};text-align:right;color:red;font-weight:bold">${formatCurrency(calculationData.additionalMonthlyNeeded)}/month</td></tr>`);

    if (calculationData?.wealthMultiplier)
      rows.push(`<tr><td style="${s};font-weight:bold">Wealth Multiplier</td><td style="${s};text-align:right">${calculationData.wealthMultiplier.toFixed(2)}x</td></tr>`);
    if (calculationData?.inflationAdjustedValue)
      rows.push(`<tr><td style="${s};font-weight:bold">Inflation Adjusted</td><td style="${s};text-align:right">${formatLargeNumber(calculationData.inflationAdjustedValue)}</td></tr>`);
    if (calculationData?.regularSIPFutureValue) {
      rows.push(`<tr><td style="${s};font-weight:bold">Regular SIP Value</td><td style="${s};text-align:right">${formatLargeNumber(calculationData.regularSIPFutureValue)}</td></tr>`);
      rows.push(`<tr><td style="${s};font-weight:bold">Extra Gain</td><td style="${s};text-align:right">${formatLargeNumber(calculationData.extraGain)}</td></tr>`);
      rows.push(`<tr><td style="${s};font-weight:bold">Additional Return</td><td style="${s};text-align:right">+${calculationData.gainPercentage}%</td></tr>`);
    }
    return rows.join('');
  };

  


  const getYearlyTableHtml = () => {
    const chartData = calculationData?.chartData || [];
    if (chartData.length === 0) return '';
    if (calculatorType === 'Marriage' || calculatorType === 'Child Education') return '';

    if (calculatorType === 'ComboCalculator') {
      const sipRows = chartData.map((data) => {
        const currentAge = userInputs?.currentAge || 30; // default for combo projection
        return `<tr>
          <td style="padding:10px;border:1px solid #ddd;text-align:center">${data.year}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:center">${currentAge + data.year}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatCurrency(data.regularInvested)}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatCurrency(data.regularSipValue)}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right;color:#11927d">${formatCurrency(data.invested)}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right;font-weight:bold;color:#1f4b8f">${formatCurrency(data.sipValue)}</td>
        </tr>`;
      }).join('');

      let swpTable = '';
      if (calculationData.withdrawalChartData && calculationData.withdrawalChartData.length > 0) {
        const swpRows = calculationData.withdrawalChartData.map((data) => {
          return `<tr>
            <td style="padding:10px;border:1px solid #ddd;text-align:center">${data.year}</td>
            <td style="padding:10px;border:1px solid #ddd;text-align:center">${calculationData.withdrawalStartAge + data.year}</td>
            <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatCurrency(data.regularWithdrawn)}</td>
            <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatCurrency(data.regularBalance)}</td>
            <td style="padding:10px;border:1px solid #ddd;text-align:right;color:#e07a00">${formatCurrency(data.withdrawn)}</td>
            <td style="padding:10px;border:1px solid #ddd;text-align:right;font-weight:bold;color:#1f4b8f">${formatCurrency(data.balance)}</td>
          </tr>`;
        }).join('');

        swpTable = `
          <div class="html2pdf__page-break" style="padding-top:20px;">
            <h3 style="color:#2e56b8;margin:0 0 15px 0;font-size:18px;text-align:center;">Withdrawal Journey - Year by Year</h3>
            <table style="width:100%;border-collapse:collapse;font-size:13px; font-family:Arial,sans-serif;">
              <thead>
                <tr style="background:#f4f4f4;color:#333;">
                  <th style="padding:12px;border:1px solid #ddd;text-align:center">Year</th>
                  <th style="padding:12px;border:1px solid #ddd;text-align:center">Age</th>
                  <th style="padding:12px;border:1px solid #ddd;text-align:right">Reg. Withdrawn</th>
                  <th style="padding:12px;border:1px solid #ddd;text-align:right">Reg. Balance</th>
                  <th style="padding:12px;border:1px solid #ddd;text-align:right">Step-up Withdrawn</th>
                  <th style="padding:12px;border:1px solid #ddd;text-align:right">Step-up Balance</th>
                </tr>
              </thead>
              <tbody>${swpRows}</tbody>
            </table>
          </div>
        `;
      }

      return `
        <div class="html2pdf__page-break" style="padding-top:20px;">
          <h3 style="color:#2e56b8;margin:0 0 15px 0;font-size:18px;text-align:center;">SIP Growth Journey - Year by Year</h3>
          <table style="width:100%;border-collapse:collapse;font-size:13px; font-family:Arial,sans-serif;">
            <thead>
              <tr style="background:#f4f4f4;color:#333;">
                <th style="padding:12px;border:1px solid #ddd;text-align:center">Year</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:center">Age</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">Reg. Invested</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">Reg. Value</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">Step-up Invested</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">Step-up Value</th>
              </tr>
            </thead>
            <tbody>${sipRows}</tbody>
          </table>
        </div>
        ${swpTable}
      `;
    }

    if (calculatorType === 'SWP') {
      const rows = chartData.map((row) => {
        const yearNumber = typeof row.year === 'string' ? row.year.replace(/Year\s*|Y/gi, '').trim() : row.year;
        return `<tr>
          <td style="padding:10px;border:1px solid #ddd;text-align:center">${yearNumber}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatLargeNumber(row.balance + row.withdrawn)}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatLargeNumber(row.withdrawn)}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatLargeNumber(row.cumulativeWithdrawn)}</td>
          <td style="padding:10px;border:1px solid #ddd;text-align:right;font-weight:bold">${formatLargeNumber(row.balance)}</td>
        </tr>`;
      }).join('');

      return `
        <div class="html2pdf__page-break" style="padding-top:20px;">
          <h3 style="color:#2e56b8;margin:0 0 15px 0;font-size:18px;text-align:center;">Withdrawal Journey - Year by Year</h3>
          <table style="width:100%;border-collapse:collapse;font-size:13px; font-family:Arial,sans-serif;">
            <thead>
              <tr style="background:#f4f4f4;color:#333;">
                <th style="padding:12px;border:1px solid #ddd;text-align:center">Year</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">Opening Balance (Rs.)</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">Yearly Withdrawal (Rs.)</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">Total Withdrawn (Rs.)</th>
                <th style="padding:12px;border:1px solid #ddd;text-align:right">End Balance (Rs.)</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
            <tfoot>
              <tr style="background:#fff;font-weight:bold;">
                <td colspan="4" style="padding:10px;border:1px solid #e0b020;text-align:center;font-size:14px;">Total Withdrawn</td>
                <td style="padding:10px;border:1px solid #e0b020;text-align:right;color:red;font-size:14px;">${formatLargeNumber(calculationData?.totalWithdrawn || 0)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      `;
    }

    const rows = chartData.map((row) => {
      const yearNumber = typeof row.year === 'string' ? row.year.replace(/Year\s*|Y/gi, '').trim() : row.year;
      const amountDeposited = row.amountDeposited !== undefined ? row.amountDeposited : row.investment;
      const returnsEarned = row.returnsEarned !== undefined ? row.returnsEarned : (row.value - row.investment);
      return `<tr>
        <td style="padding:10px;border:1px solid #ddd;text-align:center">${yearNumber}</td>
        <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatLargeNumber(amountDeposited)}</td>
        <td style="padding:10px;border:1px solid #ddd;text-align:right">${formatLargeNumber(returnsEarned)}</td>
        <td style="padding:10px;border:1px solid #ddd;text-align:right;font-weight:bold">${formatLargeNumber(row.value)}</td>
      </tr>`;
    }).join('');

    let totalDeposited = calculationData?.totalInvestment || 0;
    let totalReturns = calculationData?.estimatedReturns || 0;
    let finalBalance = calculationData?.futureValue || (calculationData?.sipFV) || 0;

    return `
      <div class="html2pdf__page-break" style="padding-top:20px;">
        <h3 style="color:#2e56b8;margin:0 0 15px 0;font-size:18px;text-align:center;">Year-by-Year Projection</h3>
        <table style="width:100%;border-collapse:collapse;font-size:13px; font-family:Arial,sans-serif;">
          <thead>
            <tr style="background:#f4f4f4;color:#333;">
              <th style="padding:12px;border:1px solid #ddd;text-align:center">Year</th>
              <th style="padding:12px;border:1px solid #ddd;text-align:right">Amount Deposited (Rs.)</th>
              <th style="padding:12px;border:1px solid #ddd;text-align:right">Returns Earned (Rs.)</th>
              <th style="padding:12px;border:1px solid #ddd;text-align:right">End Balance (Rs.)</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
          <tfoot>
            <tr style="background:#fff;font-weight:bold;">
              <td style="padding:10px;border:1px solid #ddd;text-align:center;font-size:14px;">Total</td>
              <td style="padding:10px;border:1px solid #ddd;text-align:right;">${formatLargeNumber(totalDeposited)}</td>
              <td style="padding:10px;border:1px solid #ddd;text-align:right;">${formatLargeNumber(totalReturns)}</td>
              <td style="padding:10px;border:1px solid #ddd;text-align:right;color:#2e56b8;">${formatLargeNumber(finalBalance)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    `;
  };

  const getPDFHtml = () => {
    const clientNameDisplay = formData.name 
      ? (formData.name.toLowerCase().startsWith('mr') || formData.name.toLowerCase().startsWith('ms') 
          ? formData.name 
          : `Mr/Ms ${formData.name}`) 
      : 'Valued Client';

    const logoUrl = `${window.location.origin}/images/logo.png`;

    const coverPageHTML = `
      <!-- PAGE 1: COVER PAGE -->
      <div style="width:100%; min-height:980px; background-color:#fcfaf5; padding:40px; box-sizing:border-box; border:2px solid #eee; position:relative;">
        <div style="margin-top:80px; padding-left:20px;">
          <p style="font-size:24px; color:#4a4a4a; margin:0 0 10px 0;">Shaping your</p>
          ${calculatorType === 'SWP' 
            ? `<h1 style="font-size:52px; color:#e04a3a; margin:0; line-height:1.1;">Retirement</h1>` 
            : `<h1 style="font-size:48px; color:#e04a3a; margin:0; line-height:1.2;">GROWTH & <br/> RETIREMENT JOURNEY</h1>`
          }
          <div style="display:flex; align-items:flex-end; margin-top:20px;">
            <p style="font-size:24px; color:#e0b020; margin:0 15px 10px 0;">with</p>
            <h1 style="font-size:${calculatorType.length > 12 ? '55px' : '80px'}; color:#0e2a9e; margin:0; font-weight:900; line-height:1;">${calculatorType}</h1>
          </div>
        </div>

        <div style="margin-top:150px; padding-left:20px;">
          <p style="font-size:18px; color:#222; margin:0; font-weight:bold;">Prepared for :</p>
          <h2 style="font-size:38px; color:#1f4b8f; margin:10px 0;">${clientNameDisplay}</h2>
          <p style="font-size:14px; color:#666; margin:0;">as on ${dateStr}</p>
        </div>

        <div style="position:absolute; bottom:50px; left:40px; width:calc(100% - 80px); display:flex; justify-content:space-between; align-items:flex-end;">
          <div>
            <img src="${logoUrl}" style="max-width:180px;" alt="Wisdom Consultancy" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />
            <h2 style="display:none; color:#11927d; margin:0; font-size:24px;">WISDOM CONSULTANCY</h2>
          </div>
          <div style="text-align:left; max-width:350px;">
            <p style="font-size:14px; color:#1f4b8f; margin:0 0 8px 0; font-weight:bold;">Prepared by:</p>
            <h3 style="font-size:18px; color:#f08c00; margin:0 0 10px 0; text-transform:uppercase;">YAGNESHKUMAR RAJESHBHAI DOLE</h3>
            <p style="font-size:10px; color:#4a4a4a; margin:0 0 6px 0; font-weight:bold;">AMFI REGISTERED MUTUAL FUND DISTRIBUTOR (ARN-185896)</p>
            <p style="font-size:9px; color:#4a4a4a; margin:0 0 4px 0; line-height:1.6;">📍 S O RAJESHBHAI DOLE E 44, VASANT VIHAR SOCIETY, GIDC-VADSAR ROAD M I ESTATE<br/>🏢 Vadodara<br/>✉ 390010<br/>📞 9726344477<br/>✉ wisdom2secure@gmail.com</p>
          </div>
        </div>
      </div>
    `;

    const reportHeaderHTML = `
      <div style="border-bottom:3px solid #1f4b8f;padding-bottom:16px;margin-bottom:20px;display:flex;justify-content:space-between;align-items:flex-start">
        <div>
          <h1 style="color:#11927d;font-size:26px;margin:0 0 6px 0;font-weight:900;">WISDOM CONSULTANCY</h1>
        </div>
        <div style="text-align:right">
          <p style="margin:0;font-size:11px;color:#999">ARN No: ARN-185896</p>
          <p style="margin:4px 0 0 0;font-size:11px;color:#999">Date: ${dateStr}</p>
        </div>
      </div>
    `;

    const footerHTML = `
      <div style="background:#fff8e1;padding:14px 18px;border-radius:10px;margin-top:30px;margin-bottom:18px;border-left:4px solid #f0a500">
        <p style="font-weight:bold;color:#7a4f00;margin:0 0 6px 0;font-size:13px">DISCLAIMER</p>
        <p style="font-size:11px;color:#666;margin:0;line-height:1.7">This illustration and the assumed returns are prepared on the basis of your request. These are neither indicative nor guaranteed. Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully before investing.</p>
      </div>
      <div style="border-top:2px solid #2e56b8;padding-top:12px;text-align:center">
        <p style="font-size:13px;color:#2e56b8;font-weight:bold;margin:4px 0">Wisdom Consultancy - Your Trusted Financial Partner</p>
        <p style="font-size:11px;color:#666;margin:4px 0">Phone: +91 9726344477 | Email: wisdom2secure@gmail.com</p>
        <p style="font-size:10px;color:#aaa;margin:6px 0 0 0">This is a computer-generated report. ARN No: ARN-185896</p>
      </div>
    `;

    if (calculatorType === 'SWP') {
      return `
        <div style="font-family:Arial,sans-serif;color:#222;background:#fff">
          ${coverPageHTML}
          
          <div class="html2pdf__page-break" style="padding:20px 0;">
            ${reportHeaderHTML}
            
            <h2 style="color:#000;margin:0 0 4px 0;font-size:18px">Investment Plan for</h2>
            <h1 style="color:#1f4b8f;margin:0 0 20px 0;font-size:28px">Secured Retirement</h1>

            <table style="width:100%; border-collapse:separate; border-spacing:0 8px; font-size:14px; font-weight:bold;">
              <tr>
                <td style="width:50%; padding:8px 15px; border:2px solid #e0b020; border-radius:20px; color:#1f4b8f;">Current Age</td>
                <td style="width:50%; padding:8px 15px; background:#e07a00; color:#fff; border-radius:20px; text-align:left;">50 Years</td>
              </tr>
              <tr>
                <td style="padding:8px 15px; border:2px solid #e0b020; border-radius:20px; color:#1f4b8f;">Initial Investment</td>
                <td style="padding:8px 15px; background:#e07a00; color:#fff; border-radius:20px; text-align:left;">${formatLargeNumber(userInputs?.lumpsumAmount || 0)}</td>
              </tr>
              <tr>
                <td style="padding:8px 15px; border:2px solid #e0b020; border-radius:20px; color:#1f4b8f;">Monthly Withdrawal Amount</td>
                <td style="padding:8px 15px; background:#e07a00; color:#fff; border-radius:20px; text-align:left;">${formatLargeNumber(userInputs?.monthlyWithdrawal || 0)}</td>
              </tr>
              <tr>
                <td style="padding:8px 15px; border:2px solid #e0b020; border-radius:20px; color:#1f4b8f;">Assumed Inflation</td>
                <td style="padding:8px 15px; background:#e07a00; color:#fff; border-radius:20px; text-align:left;">NA</td>
              </tr>
              <tr>
                <td style="padding:8px 15px; border:2px solid #e0b020; border-radius:20px; color:#1f4b8f;">Withdrawal Start Age</td>
                <td style="padding:8px 15px; background:#e07a00; color:#fff; border-radius:20px; text-align:left;">50 Years</td>
              </tr>
              <tr>
                <td style="padding:8px 15px; border:2px solid #e0b020; border-radius:20px; color:#1f4b8f;">Calculation Period</td>
                <td style="padding:8px 15px; background:#e07a00; color:#fff; border-radius:20px; text-align:left;">${calculationData?.years || 0} Years</td>
              </tr>
            </table>

            <h2 style="color:#000;margin:30px 0 4px 0;font-size:18px">Proposed</h2>
            <h1 style="color:#1f4b8f;margin:0 0 20px 0;font-size:28px">Asset Allocation</h1>

            <table style="width:100%; border-collapse:separate; border-spacing:0 8px; font-size:14px;">
              <thead>
                <tr>
                  <th style="background:#d32f2f; color:#fff; padding:8px; border-radius:20px; width:33%;">Asset Class</th>
                  <th style="background:#e07a00; color:#fff; padding:8px; border-radius:20px; width:33%;">Allocation</th>
                  <th style="background:#c0ca33; color:#fff; padding:8px; border-radius:20px; width:33%;">Assumed Return</th>
                </tr>
              </thead>
              <tbody style="text-align:center; color:#1f4b8f; font-weight:bold;">
                <tr>
                  <td style="border:1px solid #d32f2f; border-radius:20px; padding:6px;">Equity</td>
                  <td style="border:1px solid #e07a00; border-radius:20px; padding:6px;">100%</td>
                  <td style="border:1px solid #c0ca33; border-radius:20px; padding:6px;">${userInputs?.expectedReturn || 0}%</td>
                </tr>
                <tr>
                  <td style="border:1px solid #d32f2f; border-radius:20px; padding:6px;">Hybrid</td>
                  <td style="border:1px solid #e07a00; border-radius:20px; padding:6px;">0%</td>
                  <td style="border:1px solid #c0ca33; border-radius:20px; padding:6px;">9.00%</td>
                </tr>
                <tr>
                  <td style="border:1px solid #d32f2f; border-radius:20px; padding:6px;">Debt</td>
                  <td style="border:1px solid #e07a00; border-radius:20px; padding:6px;">0%</td>
                  <td style="border:1px solid #c0ca33; border-radius:20px; padding:6px;">6.00%</td>
                </tr>
                <tr>
                  <td style="border:1px solid #d32f2f; border-radius:20px; padding:6px;">Commodity</td>
                  <td style="border:1px solid #e07a00; border-radius:20px; padding:6px;">0%</td>
                  <td style="border:1px solid #c0ca33; border-radius:20px; padding:6px;">9.00%</td>
                </tr>
                <tr>
                  <td style="border-bottom:2px solid #d32f2f; padding:8px;">Portfolio</td>
                  <td style="border-bottom:2px solid #e07a00; padding:8px;">100%</td>
                  <td style="border-bottom:2px solid #c0ca33; padding:8px;">${userInputs?.expectedReturn || 0}%</td>
                </tr>
              </tbody>
            </table>

            <table style="width:100%; margin-top:30px; border-collapse:collapse; border:2px solid #e07a00; border-radius:20px;">
              <tr>
                <td style="width:50%; text-align:center; padding:20px; border-right:2px solid #e07a00;">
                  <p style="margin:0 0 5px 0; font-size:18px; color:#333;">Total Withdrawal Amount</p>
                  <h2 style="margin:0; font-size:32px; color:#1f4b8f;">${formatLargeNumber(calculationData?.totalWithdrawn || 0)}</h2>
                </td>
                <td style="width:50%; text-align:center; padding:20px;">
                  <p style="margin:0 0 5px 0; font-size:18px; color:#333;">Remaining Value*</p>
                  <h2 style="margin:0; font-size:32px; color:#e07a00;">${formatLargeNumber(calculationData?.finalBalance || 0)}</h2>
                </td>
              </tr>
            </table>
            
            ${footerHTML}
          </div>

          ${getYearlyTableHtml()}
        </div>
      `;
    }

    return `
      <div style="font-family:Arial,sans-serif;color:#222;background:#fff">
        ${coverPageHTML}
        
        <!-- PAGE 2: REPORT -->
        <div class="html2pdf__page-break" style="padding:10px 0;">
          ${reportHeaderHTML}

          <h2 style="text-align:center;color:#0b1c39;margin:0 0 4px 0;font-size:20px">${calculatorType} Investment Summary</h2>
          <p style="text-align:center;font-size:12px;color:#999;margin:0 0 20px 0">Detailed Financial Analysis</p>

          <div style="background:#f0f5ff;padding:14px 18px;border-radius:10px;margin-bottom:18px;border-left:4px solid #2e56b8">
            <h3 style="color:#2e56b8;margin:0 0 10px 0;font-size:14px">CLIENT INFORMATION</h3>
            <table style="width:100%;font-size:13px;border-collapse:collapse">
              <tr>
                <td style="padding:4px 8px;color:#555;width:40%">Client Name:</td>
                <td style="padding:4px 8px;font-weight:bold">${formData.name}</td>
                <td style="padding:4px 8px;color:#555;width:20%">Mobile:</td>
                <td style="padding:4px 8px;font-weight:bold">${formData.phone}</td>
              </tr>
              <tr>
                <td style="padding:4px 8px;color:#555">Email:</td>
                <td style="padding:4px 8px;font-weight:bold">${formData.email || 'Not provided'}</td>
                <td style="padding:4px 8px;color:#555">Location:</td>
                <td style="padding:4px 8px;font-weight:bold">${formData.location || 'Not provided'}</td>
              </tr>
            </table>
          </div>

          <div style="background:#f5f7fa;padding:14px 18px;border-radius:10px;margin-bottom:18px">
            <h3 style="color:#2e56b8;margin:0 0 10px 0;font-size:14px">INVESTMENT PARAMETERS</h3>
            <table style="width:100%;border-collapse:collapse;font-size:13px">
              <thead>
                <tr style="background:#2e56b8;color:#fff">
                  <th style="padding:8px 12px;border:1px solid #2e56b8;text-align:left">Parameter</th>
                  <th style="padding:8px 12px;border:1px solid #2e56b8;text-align:right">Value</th>
                </tr>
              </thead>
              <tbody>${getSummaryRowsHtml()}</tbody>
            </table>
          </div>

          <div style="background:#2e56b8;padding:18px 20px;border-radius:10px;text-align:center;margin-bottom:18px">
            <p style="color:rgba(255,255,255,0.8);margin:0 0 6px 0;font-size:13px">ESTIMATED TOTAL CORPUS</p>
            <h2 style="color:#fff;margin:0;font-size:32px;letter-spacing:1px">${formatLargeNumber(mainCorpus)}</h2>
          </div>

          <table style="width:100%;margin-bottom:18px;border-collapse:separate;border-spacing:8px">
            <tr>
              <td style="background:#f0f5ff;padding:14px;border-radius:10px;text-align:center;border:1px solid #dce7ff">
                <p style="margin:0 0 4px 0;font-size:11px;color:#666;text-transform:uppercase">Total Invested</p>
                <p style="margin:0;font-size:20px;font-weight:bold;color:#2e56b8">${formatLargeNumber(totalInvestment)}</p>
              </td>
              <td style="background:#f0fff4;padding:14px;border-radius:10px;text-align:center;border:1px solid #c3e6cb">
                <p style="margin:0 0 4px 0;font-size:11px;color:#666;text-transform:uppercase">Returns Generated</p>
                <p style="margin:0;font-size:20px;font-weight:bold;color:#2d8a4e">${formatLargeNumber(totalReturns)}</p>
              </td>
              <td style="background:#fff8f0;padding:14px;border-radius:10px;text-align:center;border:1px solid #ffd999">
                <p style="margin:0 0 4px 0;font-size:11px;color:#666;text-transform:uppercase">Inflation Adjusted</p>
                <p style="margin:0;font-size:20px;font-weight:bold;color:#b85c00">${calculationData?.inflationAdjustedValue ? formatLargeNumber(calculationData.inflationAdjustedValue) : 'N/A'}</p>
              </td>
            </tr>
          </table>

          <div style="background:#f5f7fa;padding:14px 18px;border-radius:10px;margin-bottom:18px">
            <h3 style="color:#2d8a4e;margin:0 0 10px 0;font-size:14px">RESULT SUMMARY</h3>
            <table style="width:100%;border-collapse:collapse;font-size:13px">
              <thead>
                <tr style="background:#2d8a4e;color:#fff">
                  <th style="padding:8px 12px;border:1px solid #2d8a4e;text-align:left">Parameter</th>
                  <th style="padding:8px 12px;border:1px solid #2d8a4e;text-align:right">Value</th>
                </tr>
              </thead>
              <tbody>${getResultRowsHtml()}</tbody>
            </table>
          </div>

          ${getYearlyTableHtml()}
          ${footerHTML}
        </div>
      </div>
    `;
  };

  const generatePDF = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const pdfHtml = getPDFHtml();
        
        const opt = {
          margin: [10, 10, 10, 10],
          filename: `Wisdom_${calculatorType.replace(/\s/g, '_')}_Report_${formData.name.replace(/\s/g, '_')}.pdf`,
          image: { type: 'jpeg', quality: 0.95 },
          html2canvas: { 
            scale: 2,
            useCORS: true,
            logging: false,
            windowWidth: 794
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // Use html string directly — most reliable method, no DOM visibility issues
        await html2pdf().set(opt).from(pdfHtml).save();
        resolve();
      } catch (err) {
        console.error('PDF Error:', err);
        reject(err);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      // Save lead to localStorage
      const existingLeads = JSON.parse(
        localStorage.getItem('wisdom_leads') || '[]'
      );

      const newLead = {
        ...formData,
        calculatorType,
        calculationData: calculationData ? JSON.stringify(calculationData) : null,
        userInputs: userInputs ? JSON.stringify(userInputs) : null,
        createdAt: new Date().toISOString(),
      };

      existingLeads.unshift(newLead);
      localStorage.setItem('wisdom_leads', JSON.stringify(existingLeads));

      toast.success('Details submitted successfully! Generating PDF...');

      await generatePDF();

      toast.success('PDF Report downloaded successfully!');

      onSubmit(formData);
      setIsSubmitting(false);

    } catch (error) {
      console.error(error);
      toast.error('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className="relative bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* HEADER */}
          <div className="bg-gradient-to-r from-[#1a3a5c] to-[#2c5f8a] p-6 text-white relative">
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
            >
              <FaTimes size={20} />
            </button>

            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center backdrop-blur-md">
                <FaChartLine size={28} />
              </div>
              <div>
                <h3 className="text-2xl font-bold">
                  Financial Report
                </h3>
                <p className="text-sm text-white/90 mt-1">
                  Download your personalized {calculatorType} report
                </p>
              </div>
            </div>
          </div>

          {/* BODY */}
          <div className="p-6">
            <div className="text-center mb-6">
              <h4 className="text-xl font-bold text-gray-900">
                Wisdom Consultancy
              </h4>
              <p className="text-sm text-gray-500 mt-2">
                Professional Financial Planning & Wealth Solutions
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* NAME */}
              <div className="relative">
                <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Full Name *"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                  required
                />
              </div>

              {/* PHONE */}
              <div className="relative">
                <FaPhone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="tel"
                  placeholder="Mobile Number *"
                  value={formData.phone}
                  onChange={(e) => handleChange('phone', e.target.value.replace(/\D/g, ''))}
                  maxLength={10}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                  required
                />
              </div>

              {/* EMAIL */}
              <div className="relative">
                <FaEnvelope className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                />
              </div>

              {/* LOCATION */}
              <div className="relative">
                <FaMapMarkerAlt className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="City / State"
                  value={formData.location}
                  onChange={(e) => handleChange('location', e.target.value)}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                />
              </div>

              {/* BENEFITS */}
              <div className="bg-[#f8fafc] rounded-2xl p-4 border border-gray-100 space-y-3">
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <FaDownload className="text-[#2e56b8]" />
                  Professional PDF Report
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <FaWhatsapp className="text-green-600" />
                  WhatsApp Consultation Support
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <span className="text-green-600 font-bold">✓</span>
                  Free Financial Guidance
                </div>
              </div>

              {/* BUTTON */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#2e56b8] to-[#24479b] text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '⏳ Generating Report...' : '📥 Download Financial Report'}
              </button>

              {/* DISCLAIMER */}
              <p className="text-xs text-center text-gray-400 leading-relaxed">
                By submitting this form, you agree to receive communication from Wisdom Consultancy.
                Mutual Fund investments are subject to market risks. Read all scheme related documents carefully before investing.
              </p>
            </form>
          </div>
        </motion.div>
      </motion.div>

      {/* Hidden container for PDF generation */}
      <div id="pdf-content" style={{position:'fixed',left:-9999,top:0,width:740}}></div>
    </AnimatePresence>
  );
};

export default CalculatorForm;

